import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "template-wrapper" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "list-title" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "list-item-index" }
const _hoisted_7 = { class: "list-item-name" }
const _hoisted_8 = { class: "list-item-action" }
const _hoisted_9 = { class: "right" }

import draggable from 'vuedraggable'
import { useRouter } from 'vue-router'
import { Plus, Edit, Delete, Select, CloseBold, Rank } from '@element-plus/icons-vue'
import { fetchCreate, fetchUpdate, fetchList, fetchDelete, fetchSort } from '@/api/template'
import MergeGrid from '@/components/MergeGrid/index.vue'
import { createDefaultGridData, normalizeMergeGridData } from '@/components/MergeGrid/layout'
import Breadcrumb from '@/components/Breadcrumb.vue'
import ApplicationDrag from '@/components/Application/Drag.vue'
import { onMounted } from 'vue'
import { ElMessage } from 'element-plus'
// import ApplicationTemplateDrag from '@/components/Application/TemplateDrag.vue'

const DEFAULTCODE = '99'
const group = 'template'

export default {
  __name: 'Template',
  setup(__props) {

const router = useRouter()
let tempTemplateSeed = 0

const mergeGrid = ref(null)
const templateList = ref([])
const sortLoading = ref(false)

const activeIndex = computed(() => {
  return templateList.value.findIndex(v => v.active)
})

const disabled = computed(() => {
  return templateList.value?.[activeIndex.value]?.statusCode === DEFAULTCODE
})

const sortDisabled = computed(() => {
  return sortLoading.value
    || templateList.value.filter(item => isSortableTemplate(item)).length < 2
    || templateList.value.some(item => item.edit || item.loading || !item.id)
})

const isDefaultTemplate = (item = {}) => {
  return item?.statusCode === DEFAULTCODE
}

const isSortableTemplate = (item = {}) => {
  return Boolean(item?.id) && !isDefaultTemplate(item)
}

const parseFrameworkValue = (frameworkValue) => {
  if (!frameworkValue) {
    return createDefaultGridData()
  }
  if (Array.isArray(frameworkValue)) {
    return normalizeMergeGridData(frameworkValue)
  }

  try {
    return normalizeMergeGridData(JSON.parse(frameworkValue))
  } catch (error) {
    console.error('parse template framework failed', error)
    return createDefaultGridData()
  }
}

const createTemplateItem = (item = {}) => {
  return {
    dragKey: item.dragKey || item.id || `template-${Date.now()}-${tempTemplateSeed++}`,
    ...item,
    frameworkValue: parseFrameworkValue(item.frameworkValue)
  }
}

const setActiveTemplate = (targetId = '', fallbackIndex = 0) => {
  templateList.value.forEach(item => {
    item.active = false
  })

  if (!templateList.value.length) {
    return
  }

  const matchedIndex = targetId
    ? templateList.value.findIndex(item => item.id === targetId)
    : -1
  const nextIndex = matchedIndex !== -1 ? matchedIndex : Math.min(fallbackIndex, templateList.value.length - 1)

  if (nextIndex >= 0) {
    templateList.value[nextIndex].active = true
  }
}

const getTemplateList = (targetId = '', fallbackIndex = 0) => {
  fetchList().then(res => {
    if (res) {
      templateList.value = (res || []).map(item => createTemplateItem(item))
      setActiveTemplate(targetId, fallbackIndex)
    }
  })
}

const handleChangeTemplateData = (data) => {
  if (templateList.value[activeIndex.value]) {
    templateList.value[activeIndex.value].frameworkValue = normalizeMergeGridData(data)
  }
}

const serializeFrameworkValue = (frameworkValue) => {
  return JSON.stringify(normalizeMergeGridData(frameworkValue))
}

const handleSave = () => {
  if (activeIndex.value === -1 || !mergeGrid.value) {
    return
  }
  const currentIndex = activeIndex.value
  const data = templateList.value[currentIndex]
  if (!data) {
    return
  }
  const frameworkValue = mergeGrid.value.getTableData()
  if (!data.id) {
    const { active, edit, loading, dragKey, ...payload } = data
    data.loading = true
    fetchCreate({
      ...payload,
      frameworkValue: serializeFrameworkValue(frameworkValue)
    }).then(res => {
      data.loading = false
      if (res) {
        ElMessage.success('保存成功')
        getTemplateList('', currentIndex)
      }
    })
    return
  }

  data.loading = true
  fetchUpdate({
    id: data.id,
    frameworkValue: serializeFrameworkValue(frameworkValue)
  }).then(res => {
    data.loading = false
    if (res) {
      ElMessage.success('保存成功')
      data.frameworkValue = frameworkValue
    }
  })
}

const handleBack = () => {
  router.back()
}

// 创建模板
const handleCreate = () => {
  if (activeIndex.value !== -1) {
    templateList.value[activeIndex.value].active = false
  }

  templateList.value.unshift(createTemplateItem({
    active: true,
    edit: true,
    frameworkValue: createDefaultGridData()
  }))
}

const handleActive = (index) => {
  if (!templateList.value[index].edit) {
    if (activeIndex.value !== -1) {
      templateList.value[activeIndex.value].active = false
    }
    templateList.value[index].active = true
  }
}

const handleShowEdit = (index) => {
  templateList.value[index].edit = true
}

// 删除模板
const handleDelete = (index) => {
  const data = templateList.value[index]
  if (data.id) {
    const currentActiveId = templateList.value[activeIndex.value]?.id || ''
    const nextActiveId = currentActiveId === data.id
      ? (templateList.value[index + 1]?.id || templateList.value[index - 1]?.id || '')
      : currentActiveId
    data.loading = true
    fetchDelete([data.id]).then(res => {
      data.loading = false
      if (res) {
        getTemplateList(nextActiveId)
      }
    })
  }
}

// 取消编辑状态
const handleCancel = (index) => {
  const data = templateList.value[index]
  if (!data) {
    return
  }

  if (data.id) {
    getTemplateList(data.id)
    return
  }

  const nextFallbackIndex = index > 0 ? index - 1 : 0
  templateList.value.splice(index, 1)
  setActiveTemplate('', nextFallbackIndex)
}

const handleSortChange = (event) => {
  if (!event?.moved) {
    return
  }

  const ids = templateList.value.filter(item => isSortableTemplate(item)).map(item => item.id)
  if (!ids.length) {
    return
  }

  sortLoading.value = true
  const currentActiveId = templateList.value[activeIndex.value]?.id || ''
  fetchSort(ids).then(res => {
    sortLoading.value = false
    if (res) {
      ElMessage.success('模板顺序已更新')
    }

    getTemplateList(currentActiveId)
  })
}

// 确认编辑
const handleEdit = (index) => {
  const { active, edit, loading, dragKey, ...data } = templateList.value[index]
  if (data.id) {
    templateList.value[index].loading = true
    fetchUpdate({ id: data.id, frameworkName: data.frameworkName }).then(res => {
      templateList.value[index].loading = false
      if (res) {
        templateList.value[index].edit = false
      }
    })
  } else {
    templateList.value[index].loading = true
    fetchCreate({
      ...data,
      frameworkValue: serializeFrameworkValue(data.frameworkValue)
    }).then(res => {
      templateList.value[index].loading = false
      if (res) {
        getTemplateList('', index)
      }
    })
  }
}

onMounted(() => {
  getTemplateList()
})

return (_ctx, _cache) => {
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "模板列表", -1)),
          _createVNode(_component_el_icon, { onClick: handleCreate }, {
            default: _withCtx(() => [
              _createVNode(_unref(Plus))
            ]),
            _: 1
          })
        ]),
        _createVNode(_unref(draggable), {
          modelValue: _unref(templateList),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_isRef(templateList) ? (templateList).value = $event : null)),
          "item-key": "dragKey",
          tag: "ul",
          class: "template-list",
          handle: ".list-item-order.sortable",
          disabled: _unref(sortDisabled),
          "ghost-class": "list-item-ghost",
          onChange: handleSortChange
        }, {
          item: _withCtx(({ element: item, index }) => [
            _withDirectives((_openBlock(), _createElementBlock("li", {
              class: _normalizeClass({active: item.active}),
              onClick: $event => (handleActive(index))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(['list-item-order', { sortable: isSortableTemplate(item) }]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Rank))
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("span", _hoisted_6, _toDisplayString(index + 1), 1),
              _createElementVNode("div", _hoisted_7, [
                (item.edit)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: item.frameworkName,
                      "onUpdate:modelValue": $event => ((item.frameworkName) = $event),
                      size: "small"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(item.frameworkName), 1)
                    ], 64))
              ]),
              _createElementVNode("div", _hoisted_8, [
                (item.edit)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_icon, {
                        onClick: _withModifiers($event => (handleEdit(index)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Select))
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_icon, {
                        onClick: _withModifiers($event => (handleCancel(index)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(CloseBold))
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (item.statusCode !== DEFAULTCODE)
                        ? (_openBlock(), _createBlock(_component_el_icon, {
                            key: 0,
                            onClick: _withModifiers($event => (handleShowEdit(index)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Edit))
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (item.statusCode !== DEFAULTCODE)
                        ? (_openBlock(), _createBlock(_component_el_icon, {
                            key: 1,
                            onClick: _withModifiers($event => (handleDelete(index)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Delete))
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ], 64))
              ])
            ], 10, _hoisted_5)), [
              [_directive_loading, item.loading]
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"])
      ])), [
        [_directive_loading, _unref(sortLoading)]
      ]),
      _createVNode(ApplicationDrag, {
        templateData: _unref(templateList)[_unref(activeIndex)]?.frameworkValue,
        disabled: _unref(disabled)
      }, null, 8, ["templateData", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(Breadcrumb, {
        title: "工作区",
        current: "模版"
      }, _createSlots({ _: 2 }, [
        (!_unref(disabled))
          ? {
              name: "actions",
              fn: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: handleSave
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("保存", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: handleBack }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("返回", -1)
                  ]))]),
                  _: 1
                })
              ]),
              key: "0"
            }
          : undefined
      ]), 1024),
      (_unref(activeIndex) !== -1)
        ? (_openBlock(), _createBlock(MergeGrid, {
            key: 0,
            data: _unref(templateList)[_unref(activeIndex)].frameworkValue,
            group: group,
            disabled: _unref(disabled),
            ref_key: "mergeGrid",
            ref: mergeGrid,
            onChange: handleChangeTemplateData
          }, null, 8, ["data", "disabled"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

}